module.exports = "uniform vec3 uCursorPosition;\n\nvarying vec3 vPosition;\nvarying vec2 vUv;\n\nvoid main() {\n    vec4 newPosition = modelMatrix * vec4(position, 1.0);\n\n    vUv = uv;\n    vPosition = newPosition.xyz;\n\n    gl_Position = projectionMatrix * viewMatrix * newPosition;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/libs/experience/shaders/tunnel-2/vertex.glsl
// module id = 417
// module chunks = 0